<glxy-uploader
  #uploader
  [accept]="accept"
  [maxFiles]="maxFiles"
  [maxFileSize]="maxFileSize"
  [autoUpload]="autoUpload"
  [hintText]="hintText"
  [layout]="layout"
  [descriptionText]="descriptionText"
  [buttonText]="buttonText"
  [hasError]="hasError"
  [uploadUrl]="uploadUrl"
  [numParallel]="numParallel"
  [files]="files"
  (fileUploaded)="fileUploaded.emit($event)"
  (fileUploadErrored)="fileUploadErrored.emit($event)"
  (filesChanged)="filesChanged.emit($event)"
/>
